// ============================================
// Register Page
// ============================================

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { toast } from 'react-toastify';
import { FaTimes, FaEye, FaEyeSlash } from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password || !confirmPassword) {
      toast.error('กรุณากรอกข้อมูลให้ครบถ้วน');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('รหัสผ่านไม่ตรงกัน');
      return;
    }

    if (password.length < 6) {
      toast.error('รหัสผ่านอย่างน้อย 6 ตัวอักษร');
      return;
    }

    setLoading(true);
    try {
      await register(email, password);
      toast.success('สมัครสมาชิกสำเร็จ! กรุณาเข้าสู่ระบบ');
      navigate('/login');
    } catch (error) {
      toast.error(error.message || 'สมัครสมาชิกไม่สำเร็จ');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate('/login');
  };

  return (
    <div className="register-container">
      <motion.div
        className="register-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Close Button */}
        <button className="register-close-btn" onClick={handleClose}>
          <FaTimes />
        </button>

        {/* Logo */}
        <div className="register-logo">
          <img 
            src="/images/assets/newstreaming_dark_bg--jXNTjCF.png" 
            alt="Streaming logo" 
            className="register-logo-image"
          />
        </div>

        {/* Header */}
        <div className="register-header">
          <h1>สมัครสมาชิก</h1>
        </div>

        {/* Register Form */}
        <form onSubmit={handleSubmit} className="register-form">
          {/* Email Field */}
          <div className="register-input-group">
            <input
              type="text"
              className="register-input"
              placeholder="กรุณากรอกอีเมล"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          {/* Password Field */}
          <div className="register-input-group">
            <input
              type={showPassword ? 'text' : 'password'}
              className="register-input"
              placeholder="กรุณากรอกรหัสผ่าน"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
            <button
              type="button"
              className="register-password-toggle"
              onClick={() => setShowPassword(!showPassword)}
              tabIndex={-1}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {/* Confirm Password Field */}
          <div className="register-input-group">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              className="register-input"
              placeholder="กรุณายืนยันรหัสผ่าน"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              disabled={loading}
            />
            <button
              type="button"
              className="register-password-toggle"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              tabIndex={-1}
            >
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>

          {/* Register Button */}
          <button
            type="submit"
            className="register-btn"
            disabled={loading}
          >
            {loading ? (
              <div className="spinner" style={{ width: '20px', height: '20px' }} />
            ) : (
              'สมัครสมาชิก'
            )}
          </button>
        </form>

        {/* Login Link */}
        <div className="register-login">
          <span>มีบัญชีอยู่แล้ว? </span>
          <Link to="/login" className="register-login-link">
            เข้าสู่ระบบเลย
          </Link>
        </div>

        {/* Terms */}
        <div className="register-terms">
          <span>เมื่อสมัครสมาชิก ถือว่าคุณยอมรับ </span>
          <Link to="/terms" className="register-terms-link">
            ข้อกำหนดการใช้งาน
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default Register;
